import { useEffect, useState } from "react";
import { ReadMoreProps } from "./types";
import styles from "./ReadMore.module.css";
import { useTranslation } from "react-i18next";
import { UiButton } from "@ui-monorepo/index";
import parse from "html-react-parser";

const ReadMore = ({ text, className, maxLength = 100 }: ReadMoreProps) => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState<boolean>();
  const [parseText, setParseText] = useState<React.ReactNode>(text || "");

  function isHTML(str: string) {
    if (document) {
      const a = document.createElement("div");
      a.innerHTML = str;
      for (let c = a.childNodes, i = c.length; i--;) {
        if (c[i].nodeType === 1) return true;
      }
    }

    return false;
  }

  useEffect(() => {
    if (isHTML(text || "")) {
      setParseText(parse(text || ""));
    }
  }, []);

  return (
    <div className={`${styles.textReadMore} ${className || ""}`}>
      {text &&
      <>
          <div className={`${styles.readMoreText}`}>
            {showMore ?
          parseText :
          parse(
            `${text.substring(0, maxLength)}${
            text.length > maxLength ? "..." : ""
            }`
          )}
          </div>
          {(text.split("\n").length > 3 || text.length > maxLength) &&
        <UiButton
          className={`${styles.btnSeeMore}`}
          link
          onClick={() => setShowMore((s) => !s)}>

              {showMore ?
          `${(t("readMore.see_less") as any)}` : (
          t("readMore.see_more") as any)}
            </UiButton>}

        </>}

    </div>);

};

export default ReadMore;